module.exports = __webpack_public_path__ + "static/media/menuGoogle.fa945537.svg";